export enum DeviceType {
  WEB_APP = 'web',
  IOS_APP = 'ios_app',
  ANDROID_APP = 'android_app',
}

export enum UserType {
  GUARDIAN = 'guardians',
  COMPETITION = 'competition',
  STUDIO = 'studio',
}

export enum ShopViewState {
  RECENT = 'Recent Events',
  ALL = 'All Events',
}

export enum AuthViewState {
  LOGIN = 'login',
  SIGNUP = 'signup',
}

export enum MediaViewState {
  RECITAL = 'recital',
  COMPETITION = 'competition',
}

export enum ShopLookupType {
  SEASONS = 'seasons',
  COMPETITIONS = 'competitions',
  EVENTS = 'events',
  STUDIOS = 'studios',
  ROUTINES = 'routines',
  DANCERS = 'dancers',
}

export enum StyleDisplay {
  BLOCK = 'block',
  NONE = 'none',
}

export enum ShopTooltipViewState {
  HOW_TO_SHOP = 'How To Shop?',
  PRICE_LIST = 'Price List',
}

export enum CardType {
	VISA = 'VISA',
	MASTER = 'MASTER',
	MASTERCARD = 'MASTER',
	AMEX = 'AMEX',
	discover = 'discover',
}

export enum RealCardType {
	VISA = 'VISA',
	MC = 'MASTER',
	AMEX = 'AMEX',
	DISC = 'discover',
	PP = 'PayPal',
	CUP = 'UnionPay'
}

export enum AndroidAlbumPath {
	PHOTO = 'Camera',
	VIDEO = 'Movies'
}

export enum PhotoSorting {
	REGULAR = 'Regular',
	AI = 'AI',
}
